import React from 'react';
import UOBox from './UOBox';
import Odd from './Odd';
import { filtraParametriche, getPrincipaleOPrimoGruppo, filterBetsByNumberOfOdds , getBetDescription } from '../data/utils';
import { CustomCols } from '../live/Live';

function OddsList(props) {
    const customCols = React.useContext(CustomCols);

    let bets = null;
    if (props.aggregata != null) {
        bets = props.bets;
    } else {
        bets = getPrincipaleOPrimoGruppo(props.gruppiScommessa).scommesse;
    }

    bets = filtraParametriche(bets);
    const filteredBets = filterBetsByNumberOfOdds(bets, customCols);

    return (
        <>
            {filteredBets.map(bet => {
                return (
                    <div key={bet.uniqueId} className="contenitoreSetQuotazioni">
                        <div className="tipologiaQuotazione_FormaCompatta grigio text-center py-1">
                            <p>{getBetDescription(bet, true)}</p>
                        </div>
                        {bet.parametrica ?
                            <UOBox betId={bet.id} bets={props.betsById.get(bet.id)} />
                            :
                            <div className="gridInterernaQuotazioni">
                                {bet.odds.map(odd => {
                                    const id = `${odd.betId}_${odd.betData.handicap}_${odd.id}`;
                                    return <Odd key={id} {...odd} />
                                })}
                            </div>
                        }
                    </div>
                )
            })}
        </>
    );
}

export default OddsList;
